import axiosInstance from "@/utils/axiosInstance";
import { Dispatch, SetStateAction } from "react";
import { toast } from "sonner";

const BASE_URL = "/drivers";

export const completeOrders = async (body: {selectedIds: number[], can_complete_order: boolean}, setOpen: Dispatch<SetStateAction<boolean>>) => {
  try {
    await axiosInstance.put(`${BASE_URL}/update-complete-order`, body);

    toast("Updated succesfully");
  } catch (err) {
    console.log(err);
    toast("Failed to update");
  } finally {
    setOpen(false)
  }
};
